import global from './global.json';
import order from './order.json';
import error from './error.json';
import ticket from './ticket.json';
import purchase from './purchase.json';
import date from './date.json';
import pagination from './pagination.json';
import page from './page.json';
import guest from './guest.json';
import event from './event.json';
import lounge from './lounge.json';
import booth from './booth.json';

export default {
  global,
  order,
  error,
  ticket,
  purchase,
  guest,
  event,
  lounge,
  date,
  pagination,
  page,
  booth
};
